import type { CarouselCardProps } from '@chegg-wt/core-wa/components/CardImageCarousel/CarouselCard'
import { AIPoweredBadge } from '@chegg-wt/core-wa/components/CardImageCarousel/AIPoweredBadge'
import { Config } from '@chegg-wt/core/config'
import { CM_PRODUCT_NAME, EB_PRODUCT_NAME } from '@chegg-wt/core/constants/site'
import { BadgeHeading } from './styled'
import {
  CM_CREATE_CITATION_CARD_ALT_TEXT,
  CM_PLAGIARISM_CARD_ALT_TEXT,
  CM_WRITING_ASSISTANT_CARD_ALT_TEXT,
  EB_CREATE_CITATION_CARD_ALT_TEXT,
  EB_PLAGIARISM_CARD_ALT_TEXT,
  EB_WRITING_ASSISTANT_CARD_ALT_TEXT,
} from './constant'

export type CarouselCardWithImage = Omit<CarouselCardProps, 'isActive'> & {
  carouselImage: string
}

export enum CardType {
  WRITING_ASSISTANT = 'WRITING_ASSISTANT',
  CREATE_CITATION = 'CREATE_CITATION',
  PLAGIARISM = 'PLAGIARISM',
}

export const cardSiteMapping = {
  [CardType.WRITING_ASSISTANT]: {
    [CM_PRODUCT_NAME]: CM_WRITING_ASSISTANT_CARD_ALT_TEXT,
    [EB_PRODUCT_NAME]: EB_WRITING_ASSISTANT_CARD_ALT_TEXT,
  },
  [CardType.CREATE_CITATION]: {
    [CM_PRODUCT_NAME]: CM_CREATE_CITATION_CARD_ALT_TEXT,
    [EB_PRODUCT_NAME]: EB_CREATE_CITATION_CARD_ALT_TEXT,
  },
  [CardType.PLAGIARISM]: {
    [CM_PRODUCT_NAME]: CM_PLAGIARISM_CARD_ALT_TEXT,
    [EB_PRODUCT_NAME]: EB_PLAGIARISM_CARD_ALT_TEXT,
  },
}

const getCardAltText = (type: CardType): string => {
  if (cardSiteMapping[type] && cardSiteMapping[type][Config.siteName]) {
    return cardSiteMapping[type][Config.siteName]
  }
}

export const getCarouselCardsWithImage = ({
  writingAssistantRoute,
  plagiarismRoute,
  createCitationRoute,
  isCitationFunnelVariant2 = false,
}): CarouselCardWithImage[] => {
  const writingAssistantCard = {
    heading: (
      <BadgeHeading>
        Enhance your writing <AIPoweredBadge />
      </BadgeHeading>
    ),
    content: getCardAltText(CardType.WRITING_ASSISTANT),
    actionButtonRoute: writingAssistantRoute,
    actionButtonText: 'Get started',
    dataTestId: 'polish-writing',
    carouselImage: 'polish-writing.webp',
  }

  const createCitationCard = {
    heading: 'Cite your sources',
    content: getCardAltText(CardType.CREATE_CITATION),
    actionButtonRoute: createCitationRoute,
    actionButtonText: 'Create citations',
    dataTestId: 'create-citations',
    carouselImage: 'generate-citations.webp',
  }

  const plagiarismCard = {
    heading: 'Check for plagiarism',
    content: getCardAltText(CardType.PLAGIARISM),
    actionButtonRoute: plagiarismRoute,
    actionButtonText: 'Scan my paper',
    dataTestId: 'check-paper',
    carouselImage: 'check-for-plagiarism.webp',
  }

  return isCitationFunnelVariant2
    ? [createCitationCard, writingAssistantCard, plagiarismCard]
    : [writingAssistantCard, createCitationCard, plagiarismCard]
}
